import React from 'react';
import ListTabs from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/common/ListTabs';
import OptionalDataTable from './OptionalDataTable';
import { useFormPayloadContext } from '@/creditflowresearch/application/PortfolioMonitor/FormPayloadContext';

const OptionalData = (props) => {
  const {
    payload: { lists = [] },
    activeListName,
    setActiveListName,
  } = useFormPayloadContext();

  const tabLists = lists.map(({ name }) => ({
    key: name, name, isDisabled: false,
  }));

  return (
    <>
      <ListTabs lists={ tabLists } selectedTab={ activeListName } onChange={ setActiveListName } />
      <OptionalDataTable { ...props } />
    </>
  );
};

export default OptionalData;
